import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Operations = () => {

  const names = ['House Keeping', 'Maintenance & PPM', 'Transport & Tiffin', 'H.R.'];

  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(selectPermissions);
  const hasModulePermission = (moduleName) => {
    const modulePermission = permissions.find(
      permission => permission.ModuleName === moduleName
    );
    
    if (!modulePermission) return false;

    return (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    );
  };


  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="House Keeping"
            />
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="Maintenance & PPM"
            />
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="Transport & Tiffin"
            />
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              title="H.R."
            />
          
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>  
         
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Operations;